module.exports = __webpack_public_path__ + "img/koerier.391ba4d6.png";